module.exports = __webpack_public_path__ + "static/media/u31.6abdb5d4.png";